var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 138.4 256",
    style: {
      enableBackground: "new 0 0 138.4 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000120517561942102648880000017336203254500670395_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.4,127.8c-1.9-1.2-3.7-2.6-5.4-4C75.8,89.7,41.6,55.6,7.4,21.5c-1.1-1-2.1-2.1-3.2-3.2 C-0.9,13.1-1.3,7.1,3,2.9s10-3.8,15.3,1.4c38.4,38.3,76.9,76.6,115.4,115c6.2,6.2,6.2,11.1,0.1,17.2 c-38.4,38.4-76.9,76.7-115.4,115c-0.9,1-1.9,1.9-3,2.6c-3.8,2.7-9,2.3-12.4-1c-3.4-3.2-4.1-8.4-1.5-12.3c1.3-1.7,2.7-3.4,4.3-4.8 c34.7-34.6,69.4-69.1,104.1-103.7C111.2,131.1,112.7,130,115.4,127.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.b5a712053e55e7329989f842ddb8c878.svg";
export { ForwardRef as ReactComponent };